module.exports = __webpack_public_path__ + "img/number_bg_01.8f2c28b4.png";